module.exports = __webpack_public_path__ + "img/FPTemp2.2f6d8b85.png";